module.exports = __webpack_public_path__ + "static/logo-8c845451ed6d5b57f3af13a2fe2dc794.png";